const StaffRoles = [
  { label: 'TEACHER', value: 'teacher' },
  { label: 'COORDINATOR', value: 'coordinator' },
  { label: 'PRINCIPAL', value: 'principal' },
  { label: 'VICE_PRINCIPAL', value: 'vicePrincipal' },
  { label: 'HEAD_OF_SCHOOL', value: 'headOfSchool' },
  { label: 'DEPUTY_HEAD_OF_SCHOOL', value: 'deputyHeadOfSchool' },
  { label: 'MODERATOR', value: 'moderator' },
  { label: 'SCHOOL_OFFICE', value: 'schoolOffice' },
  { label: 'NURSE', value: 'nurse' }
];

const NewStaffRoles = [
  { label: 'TEACHER', value: 'TEACHER' },
  { label: 'COORDINATOR', value: 'COORDINATOR' },
  { label: 'PRINCIPAL', value: 'PRINCIPAL' },
  { label: 'VICE_PRINCIPAL', value: 'VICE_PRINCIPAL' },
  { label: 'HEAD_OF_SCHOOL', value: 'HEAD_OF_SCHOOL' },
  { label: 'DEPUTY_HEAD_OF_SCHOOL', value: 'DEPUTY_HEAD_OF_SCHOOL' },
  { label: 'MODERATOR', value: 'MODERATOR' },
  { label: 'SCHOOL_OFFICE', value: 'SCHOOL_OFFICE' },
  { label: 'NURSE', value: 'NURSE' }
];

const ConfirmationDialogMessages: Record<string, string> = {
  activate_student: 'Are you sure you want to activate this user?',
  deactivate_student: 'Are you sure you want to deactivate this user?',
  enable_for_current_ay:
    'Are you sure you want to enable this user for the current academic year?',
  default: 'Are you sure you want to perform this action?'
};

const StaffActionItems: { key: string; label: string; onClick?: () => void }[] =
  [
    { key: 'enable_for_current_ay', label: 'Enable For Current AY' },
    { key: 'deactivate_student', label: 'De-Activate User' },
    { key: 'activate_student', label: 'Activate User' }
  ];

const AllowedRoleToAccessAY = ['teacher', 'coordinator', 'schoolOffice'];

export {
  StaffRoles,
  ConfirmationDialogMessages,
  StaffActionItems,
  AllowedRoleToAccessAY,
  NewStaffRoles
};
